import { render } from "./DownloadPage.vue?vue&type=template&id=dfe0a19c&scoped=true"
import script from "./DownloadPage.vue?vue&type=script&lang=js"
export * from "./DownloadPage.vue?vue&type=script&lang=js"

import "./DownloadPage.vue?vue&type=style&index=0&id=dfe0a19c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfe0a19c"]])

export default __exports__